import { ADDRESS_VALIDATION } from "../units/address-input";
import { getApiUrl } from "../utils/get-api-url";
import { CREATE_QUOTE_PAGE } from "../constants";

const buildUrl = ({ method, propertyId, productId }) => {
  const apiUrl = getApiUrl("addressservicing");
  const base = `${apiUrl}/properties`;
  if (method === "GET") return `${base}/${propertyId}/${productId}`;
  else if (method === "PUT") return `${base}/${propertyId}`;
  else return base;
};

export const fetchPropertyDetails = async ({
  signal,
  address,
  propertyId,
  productId,
  method: methodOverride
}) => {
  const method = methodOverride || (propertyId ? "PUT" : "POST");
  const body = {
    propertyStreetNumber: address.streetNumber,
    propertyStreetName: address.route,
    propertyAddressLine2: address.subpremise,
    propertyCity: address.city,
    propertyState: address.state,
    propertyZipCode: address.postalCode,
    latitude: address.lat,
    longitude: address.lng,
    geocodeMatchLevel:
      address.locationType ||
      (address.validation === ADDRESS_VALIDATION.VALIDATED ? "Validated" : ""),
    productId,
    quoteOriginationSystem: CREATE_QUOTE_PAGE.QUOTE_ORIGINATION_SYSTEM.AP
  };
  const response = await fetch(
    buildUrl({ method, propertyId, productId }) + "?async=false",
    {
      signal,
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache"
      },
      credentials: "include",
      ...(["POST", "PUT"].includes(method) && {
        body: JSON.stringify(body)
      })
    }
  );
  const rawResponse = await response.json();
  const property = rawResponse?.result.response.property;
  return {
    done: rawResponse.done,
    ...property
  };
};
